<div ngClass="root-menu" cdkMenu>
  @for (item of menu; track item.title) { @if (!item.children && item.value) {
  <button
    class="menu-item"
    cdkMenuItem
    [class.menuActive]="item.value === activeMenuItem"
    (click)="setActiveMenu(item.value)"
	  [disabled]="item.disabled"
	  [class.disabled]="item.disabled"
  >
    @if(item.svgIcon){
    <mat-icon class="d-flex me-1" [svgIcon]="item.svgIcon"></mat-icon>
    }
    <span>{{ item.title }}</span>
  </button>
  } @else {
  <button
    class="menu-item"
    cdkMenuItem
    (click)="item.isOpen = !item.isOpen"
    [class.nestedMenuActive]="false"
	  [disabled]="item.disabled"
	  [class.disabled]="item.disabled"
  >
    @if(item.svgIcon){
    <mat-icon class="d-flex me-1" [svgIcon]="item.svgIcon"></mat-icon>
    }
    <span>{{ item.title }}</span>
    <mat-icon
      class="d-flex ms-1"
      [svgIcon]="item.isOpen ? 'chevron-down' : 'chevron-right'"
    ></mat-icon>
  </button>
  @if (item.isOpen) {
  <div class="children-menu">
    @for (item of item.children; track item.title) { @if(item.value){
    <button
      class="menu-item"
      cdkMenuItem
      [class.menuActive]="item.value === activeMenuItem"
      (click)="setActiveMenu(item.value)"
    >
      @if(item.svgIcon){
      <mat-icon class="d-flex me-1" [svgIcon]="item.svgIcon"></mat-icon>
      }
      <span>{{ item.title }}</span>
    </button>
    } }
  </div>
  } } }
</div>
